import { useState } from "react";
import { TAGS } from "@/lib/helpers";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function TagControl({ tag, note, onSave, testidPrefix = "tag" }) {
  const [sel, setSel] = useState(tag || null);
  const [n, setN] = useState(note || "");
  const [busy, setBusy] = useState(false);

  const needsNote = sel === "potential" || sel === "rejected";
  const save = async () => {
    if (needsNote && !n.trim()) return toast.error("A note is required for this tag");
    setBusy(true);
    try { await onSave(sel, needsNote ? n : ""); } finally { setBusy(false); }
  };

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {TAGS.map((t) => (
          <button
            key={t.value}
            type="button"
            data-testid={`${testidPrefix}-${t.value}`}
            onClick={() => setSel(sel === t.value ? null : t.value)}
            className="border px-3 py-1.5 text-xs font-medium uppercase tracking-wider transition-colors"
            style={sel === t.value ? { color: "#fff", background: t.color, borderColor: t.color } : { color: t.color, borderColor: t.color }}
          >
            {t.label}
          </button>
        ))}
      </div>
      {needsNote && (
        <textarea
          value={n}
          onChange={(e) => setN(e.target.value)}
          data-testid={`${testidPrefix}-note`}
          placeholder={sel === "potential" ? "Why could this work?" : "Why was this rejected?"}
          rows={2}
          className="mt-2 w-full border border-zinc-200 px-2 py-1.5 text-sm outline-none focus:border-[#e84e34]"
        />
      )}
      <button onClick={save} disabled={busy} data-testid={`${testidPrefix}-save`} className="mt-2 flex items-center gap-2 bg-zinc-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-zinc-800 disabled:opacity-60">
        {busy && <Loader2 className="h-3 w-3 animate-spin" />} Save tag
      </button>
    </div>
  );
}
